import {AccountingTransactionDto} from "../../../dtos/transactions/AccountingTransactionDto";
import {format} from "date-fns";
import {DataGrid} from "devextreme-react";
import {Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel} from "devextreme-react/data-grid";
import {MovementTypeColumn} from "./MovementTypeColumn";
import React from "react";
import {defaultAccountingAmountFormat, defaultAccountingQuantityFormat} from "../../../config/appconst";

interface IProps {
    items: AccountingTransactionDto[];
}

export const AccountingTransactionTable = ({items}: IProps) => {
    const pageSizes = [10, 25, 50, 100];

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{mode: "multiple"}}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{mode: "single"}}
                    loadPanel={{enabled: true, showIndicator: true, showPane: false}}
                >
                    <ColumnChooser enabled={true}/>
                    <GroupPanel visible={true}/>
                    <SearchPanel visible={true} highlightCaseSensitive={true}/>
                    <Grouping autoExpandAll={false}/>

                    <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"}
                            sortOrder={"asc"}
                            sortIndex={1}/>
                    <Column width={150} dataField={"companyName"} dataType="string"/>

                    <Column caption={"Debit"}>
                        <Column width={75} dataField={"debitAccountNo"} dataType="string" caption={"Debit"}/>

                        <Column width={150} dataField={"debitAnalytics1Name"} dataType="string" caption={"A1"}/>
                        <Column width={150} dataField={"debitAnalytics2Name"} dataType="string" caption={"A2"}/>
                        <Column width={150} dataField={"debitAnalytics3Name"} dataType="string" caption={"A3"}/>

                        <Column width={100} dataField={"debitQuantity"} dataType="number"
                                format={defaultAccountingQuantityFormat} caption={"Quantity"}/>
                        <Column width={100} dataField={"debitCurrencyAmount"} dataType="number"
                                format={defaultAccountingAmountFormat} caption={"Curr. Amount"}/>
                        <Column width={100} dataField={"DebitCurrencyName"} dataType="string" caption={"Currency"}/>
                    </Column>

                    <Column caption={"Credit"}>
                        <Column width={75} dataField={"creditAccountNo"} dataType="string" caption={"Credit"}/>

                        <Column width={150} dataField={"creditAnalytics1Name"} dataType="string"
                                caption={"A1"}/>
                        <Column width={150} dataField={"creditAnalytics2Name"} dataType="string"
                                caption={"A2"}/>
                        <Column width={150} dataField={"creditAnalytics3Name"} dataType="string"
                                caption={"A3"}/>

                        <Column width={100} dataField={"creditQuantity"} dataType="number"
                                format={defaultAccountingQuantityFormat} caption={"Quantity"}/>
                        <Column width={100} dataField={"creditCurrencyAmount"} dataType="number"
                                format={defaultAccountingAmountFormat} caption={"Curr. Amount"}/>
                        <Column width={100} dataField={"creditCurrencyName"} dataType="string" caption={"Currency"}/>
                    </Column>
                    <Column width={100} dataField={"amount"} dataType="number" format={defaultAccountingAmountFormat}/>
                    <Column width={300} dataField={"description"} dataType="string"/>

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true}/>
                    <Paging defaultPageSize={10}/>
                </DataGrid>
            </div>
        </>
    )
}
